import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Phone, BookOpen, Rows } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Thank You · 360 View LLC";
  }, []);

  return (
    <div data-testid="thank-you-page" className="min-h-[70vh] flex items-center">
      <Seo title="Thank You" description="Your request has been received." path="/thank-you" noindex={true} />
      <div className="container-x py-16">
        <div className="max-w-3xl">
          <div className="w-16 h-16 border-2 border-solar bg-solar/10 flex items-center justify-center mb-8">
            <CheckCircle size={36} weight="fill" className="text-solar" />
          </div>
          <div className="eyebrow text-solar mb-3">Received</div>
          <h1 className="mb-6">Your request is in.</h1>
          <p className="text-white/80 text-lg leading-relaxed max-w-2xl mb-8">
            Thank you for contacting 360 View LLC. A specialist will review your site details and follow up shortly with a
            recommended configuration and next steps. Deployment timing is subject to unit availability and site location.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <a data-testid="ty-call-btn" href="tel:7029290390" className="btn-solar text-center inline-flex items-center gap-2 justify-center">
              <Phone size={16} weight="fill" /> Call 702-929-0390 for urgent needs
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-px bg-chrome border border-chrome">
            <Link to="/systems/compare" data-testid="ty-compare-link" className="bg-steel p-6 hover:bg-obsidian transition-colors">
              <Rows size={24} weight="duotone" className="text-solar mb-3" />
              <div className="font-display uppercase text-lg font-bold mb-1">Compare our systems</div>
              <div className="text-white/70 text-sm">See the differences between Mini, Standard and Pro.</div>
            </Link>
            <Link to="/resources" data-testid="ty-learn-link" className="bg-steel p-6 hover:bg-obsidian transition-colors">
              <BookOpen size={24} weight="duotone" className="text-solar mb-3" />
              <div className="font-display uppercase text-lg font-bold mb-1">Learning center</div>
              <div className="text-white/70 text-sm">Guides on solar surveillance, deployment and construction security.</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
